import { jsx } from "react/jsx-runtime";
import { cn } from "../../../common/helpers/common.utils.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const NavPills = forwardRef((props, ref) => {
  const { items, className, role = "navigation", ...rest } = props;
  return /* @__PURE__ */ jsx("div", { ...rest, ref, role, className: twMerge("relative flex items-center gap-2", className), children: items.map((itemProps, i) => {
    const { content, isActive, className: itemClassName, ...itemRest } = itemProps;
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...itemRest,
        className: cn(
          "inline-flex items-center gap-2 px-[14px] py-[6px] text-sm rounded-lg whitespace-nowrap font-medium text-grayscale-500 cursor-pointer",
          isActive && "font-semibold text-primary bg-card-color shadow-[0px_0px_2px_rgba(18,40,44,0.1),0px_2px_4px_rgba(18,40,44,0.1)]",
          itemClassName
        ),
        children: content
      },
      i
    );
  }) });
});
export {
  NavPills as default
};
//# sourceMappingURL=NavPills.js.map
